var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "formpart",
    },
    [
      _c("div", {
        ref: "list_message_field",
        staticClass: "sr-only",
        attrs: {
          "aria-live": "polite",
        },
      }),
      _vm._v(" "),
      _c(
        "ul",
        _vm._l(_vm.selected_date_list, function (date) {
          return _c(
            "li",
            _vm._b(
              {
                key: date,
              },
              "li",
              _vm.selected_date_list,
              false
            ),
            [
              _c("input", {
                attrs: {
                  type: "hidden",
                  name: _vm.input_name + "[]",
                },
                domProps: {
                  value: _vm.getISODate(date),
                },
              }),
              _vm._v(" "),
              _c("studip-date-time", {
                attrs: {
                  timestamp: Math.floor(date.getTime() / 1000),
                  date_only: true,
                },
              }),
              _vm._v(" "),
              _c("studip-icon", {
                staticClass: "enter-accessible",
                attrs: {
                  shape: "trash",
                  title: _vm.$gettext("Löschen"),
                  "aria-role": "button",
                  tabindex: "0",
                },
                on: {
                  click: _vm.removeDate,
                },
              }),
            ],
            1
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("label", [
        _vm._v("\n        " + _vm._s(_vm.$gettext("Datum")) + "\n        "),
        _c(
          "div",
          {
            staticClass: "flex-row input-with-icon",
          },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.selected_date_value,
                  expression: "selected_date_value",
                },
              ],
              ref: "date_select_input",
              attrs: {
                type: "text",
              },
              domProps: {
                value: _vm.selected_date_value,
              },
              on: {
                input: function input($event) {
                  if ($event.target.composing) return
                  _vm.selected_date_value = $event.target.value
                },
              },
            }),
            _vm._v(" "),
            _c("studip-icon", {
              staticClass: "icon enter-accessible button undecorated",
              attrs: {
                shape: "add",
                title: _vm.$gettext("Hinzufügen"),
                "aria-role": "button",
                tabindex: "0",
              },
              on: {
                click: _vm.addDate,
              },
            }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }